import React, { useCallback, useEffect, useMemo, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import Table from "../../../components/Table/Table"
import LinearProgress from "@mui/material/LinearProgress"
import axios from "axios"
import { Link } from "react-router-dom"
import Button from "@mui/material/Button"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import { logOut } from "../../../utils/logOut"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import { useSelector } from "react-redux"
import { Typography } from "@mui/material"
import ReactFlow, { MiniMap, addEdge, useEdgesState, useNodesState } from 'reactflow';
import 'reactflow/dist/style.css';
import Dagre from '@dagrejs/dagre';
import CustomNode from "../../../utils/CustomNode"
import { useSnackbar } from "../../../utils/SnackbarContext"

let customN = { 'custom-node': (el) => <CustomNode el={el} /> }

export default function SattingsUpCTVisuals() {
    const dispatch = useAppDispatch()
    const [tableData, setTableData] = useState([])
    const [loading, setLoading] = useState(false)
    const [partners, setSPartners] = useState([])
    const [conversationtemplates, setConversationtemplates] = useState([])
    const [startRow, setStartRow] = useState(0)
    const [pageRows, setPageRows] = useState(100)
    const [maxRows, setMaxRows] = useState(pageRows)
    const [totalRows, setTotalRows] = useState(0)
    const [filterParams, setFilterParams] = useState(localStorage.getItem('settingsupconversationtemplate_filter') ? JSON.parse(localStorage.getItem('settingsupconversationtemplate_filter') || '{}') : {
        recordnumberfrom: '',
        recordnumberto: '',
        conversationtemplate: '',
        command: '',
        description: '',
        enabled: ''
    })

    // const [initialNodes, setInitialNodes] = useState([
    //     { id: '1', position: { x: 0, y: 0 }, data: { label: '1' } },
    //     { id: '2', position: { x: 0, y: 0 }, data: { label: '2' } },
    //     { id: '3', position: { x: 0, y: 0 }, data: { label: '3' } },
    // ]
    // )

    // const [initialEdges, setInitialEdges] = useState([
    //     { id: 'e2-1', source: '1', target: '2', animated: true },
    //     { id: 'e2-2', source: '2', target: '3', animated: true }
    // ])
    const [nodes, setNodes, onNodesChange] = useNodesState([
        { id: '1', position: { x: 0, y: 0 }, data: { label: '1' } },
        { id: '2', position: { x: 0, y: 0 }, data: { label: '2' } },
        { id: '3', position: { x: 0, y: 0 }, data: { label: '3' } },]);
    const [edges, setEdges, onEdgesChange] = useEdgesState([
        { id: 'e2-1', source: '1', target: '2', animated: true },
        { id: 'e2-2', source: '2', target: '3', animated: true }]);


    const getLayoutedElements = (nodes, edges, options) => {
        const g = new Dagre.graphlib.Graph().setDefaultEdgeLabel(() => ({}));
        g.setGraph({
            rankdir: 'LR', // Default to 'TB' for vertical layout
            ranksep: 200, // Adjust this value to increase/decrease the vertical distance between nodes
            nodesep: 200, // Adjust this value to increase/decrease the horizontal distance between nodes
        }); // Set the direction to 'LR' for horizontal layout

        edges.forEach((edge) => g.setEdge(edge.source, edge.target));
        nodes.forEach((node) => g.setNode(node.id, node));

        Dagre.layout(g);

        return {
            nodes: nodes.map((node) => {
                const { x, y } = g.node(node.id);

                return { ...node, position: { x, y }, sourcePosition: 'right', targetPosition: 'left' };
            }),
            edges,
        };
    };

    const { showSnackbar } = useSnackbar();


    const onLayout = useCallback(() => {
        const layouted = getLayoutedElements(nodes, edges, {});

        setNodes([...layouted.nodes]);
        setEdges([...layouted.edges]);

        window.requestAnimationFrame(() => {
            // You can optionally call fitView here if needed
        });
    }, [nodes, edges]);


    useEffect(() => {
        dispatch(setCurrentPage(`Setting Up Conversation Templates`))
    }, [dispatch]);

    const accesslevel = useSelector(
        (state) => state.auth.authData.accesslevel
    )

    function saveFilterData() {
        localStorage.setItem('settingsupconversationtemplate_filter', JSON.stringify(filterParams))
    }

    //Get word group
    async function fetchData(params = {}) {
        setLoading(true)
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/command`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: { ...params, startRow, maxRows, calculatetotalcount: true }
            })
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setTotalRows(+response.data[0].totalcount)
                    setTableData(response.data.slice(1))
                    let res = response.data.slice(1)
                    setNodes(res.map((el) => {
                        return {
                            id: el.id,
                            position: { x: 0, y: 0 },
                            data: { label: `${el.shortdescription}`, recordnumber: el.recordnumber, descr: el.description },
                            type: 'custom-node',
                        }
                    }))
                    // Create edges based on recordnumber
                    const sortedEdges = res
                        .sort((a, b) => a.recordnumber - b.recordnumber)
                        .map((el, index, array) => {
                            if (index < array.length - 1 && el.shortdescription !== 'Перейти' && el.shortdescription !== "Завершить звонок") {
                                return { id: `e${el.id}-${array[index + 1].id}`, source: el.id, target: array[index + 1].id, animated: true };
                            }
                            return null;
                        })
                        .filter((edge) => edge !== null);

                    setEdges(sortedEdges);
                    // onLayout()

                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

            console.log(response.data);

            setLoading(false)
        } catch (error) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false)
        }
    }



    //Get conversationtemplate for Select field
    async function getConversationtemplates(params = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/conversationtemplate`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setConversationtemplates(response.data)
        } catch (error) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //on load - fetch data
    useEffect(() => {
        setTimeout(() => fetchData(filterParams), 0)
        getConversationtemplates()

    }, [])

    useEffect(() => {
        onLayout()
    }, [tableData])

    useEffect(() => {
        setMaxRows(pageRows)
        setStartRow(0)
    }, [filterParams])

    useEffect(() => {
        setTimeout(() => fetchData(filterParams), 0)
        getConversationtemplates()
    }, [startRow, maxRows])

    //Pagination buttons
    function handleBack() {
        if ((startRow - pageRows) < 0) {
            setStartRow(0)
            setMaxRows(pageRows)

        }
        else {
            setStartRow((prev) => prev - pageRows)
            setMaxRows((prev) => prev - pageRows)
        }
    }

    function handleNext() {

        setStartRow((prev) => prev + pageRows)
        setMaxRows((prev) => prev + pageRows)

    }

    function handleEnd() {

        setStartRow(totalRows % pageRows === 0 ? totalRows - pageRows : totalRows - (totalRows % pageRows))
        setMaxRows(totalRows % pageRows === 0 ? totalRows : totalRows - (totalRows % pageRows) + pageRows)

    }

    function handleStart() {

        setStartRow(0)
        setMaxRows(pageRows)

    }


    const totalPages = Math.ceil(totalRows / pageRows);
    const currentPage = Math.ceil(maxRows / pageRows);

    //exclusion of unnecessary table renderers
    const memoizedTable = useMemo(() => <Table rows={tableData} page={'settingsupconversationtemplate'} />, [tableData]);



    const onConnect = useCallback(
        (params) => setEdges((eds) => addEdge(params, eds)),
        [setEdges],
    );


    return (
        <Box sx={{ height: '84vh', width: '100%', display: 'flex', flexDirection: 'column', mr: 1 }}>
            <Box sx={{ mb: 3, alignItems: "center", display: 'flex', width: "100%", justifyContent: "space-between" }}>
                <Link to='/settingsupconversationtemplate' state={{ type: 'add' }}>
                    <Button size="small" sx={{ mr: 7 }} variant="outlined">Add a new command</Button>
                </Link>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, mr: 20, flexWrap: 'wrap' }}>
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label">Conversation template</InputLabel>
                        <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setFilterParams({ ...filterParams, conversationtemplate: e.target.value })} value={filterParams.conversationtemplate} variant="outlined" size="small" label='Conversation template' >
                            <MenuItem value={''}>All</MenuItem>
                            {
                                conversationtemplates.map((el) => (
                                    <MenuItem key={el.id} value={el.id}>{el.conversationtemplatecode}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>

                    <Button onClick={() => { fetchData(filterParams); saveFilterData() }} size="small" sx={{ mr: 1 }} variant="contained" >Load Template</Button>
                </Box>
                <Box></Box>
            </Box>
            {loading ? <LinearProgress sx={{ width: "50%", marginTop: '33vh', marginLeft: 'auto', marginRight: 'auto' }} /> :
                <ReactFlow
                    nodes={nodes}
                    edges={edges}
                    onNodesChange={onNodesChange}
                    onEdgesChange={onEdgesChange}
                    onConnect={onConnect}
                    nodeTypes={customN}
                >
                    <MiniMap />
                </ReactFlow>
            }
        </Box>
    )
}